<template>
    <div class="discussion">
        <div class="wrapper"
            v-for="item in list" :key="item.id">
            <div class="wrapper-content">
                <div class= "parent_top">
                    <span class = "parent_label strong">
                        {{item.label}}
                    </span>
                    <span class = "parent_comment">
                        {{item.comment}}
                    </span>
                    <div v-if="item.bast && item.bast.length" class="bast">
                        <button :class="bastButtonClass(item)" @click="showBast(item)">View Bast</button> 
                        <!-- <div v-if ="isShowBast.includes(item.id)" class="image_bast"> 
                            <grid-card :min="60" :column="'auto-fill'" :gap="8">
                                <template slot="item">
                                    <div class="img hehe" v-for="image in item.bast" :key="image.id">
                                        <img :src="image.img">
                                    </div>
                                </template>
                            </grid-card>
                        </div> -->
                    </div>
                    <div v-if="item.mockup && item.mockup.length" class="mockup">
                        <button :class="mockupButtonClass(item)" @click="showMockup(item)">View Mockup</button>
                        <!-- <div v-if ="isShowMockup.includes(item.id)" class="image_mockup"> 
                            <grid-card :min="60" :column="'auto-fill'" :gap="8">
                                <template slot="item">
                                    <div class="img hehe" v-for="image in item.mockup" :key="image.id">
                                        <img :src="image.img">
                                    </div>
                                </template>
                            </grid-card>
                        </div> -->
                    </div>
                    <div class="parent_info">
                        <span class="date small-font color-grey"> {{formatDate(item.date)}} </span>
                        <span :class="colorSelection(item)" @click="reply(item)"> Reply </span>
                    </div>
                </div>
                <div class= "parent_bottom">
                    <!-- <media :query="{maxWidth: 700}"> -->
                    <div class = "parent_bottom_add_comment">
                        <div v-if ="isShowArr.includes(item.id)" class="textArea">         
                            <textarea class ="title-large color-black" placeholder="Leave a message here" ref="content"> </textarea>
                            <div class="button-div">
                                <button class="btn-regular secondary"  @click="emitSubmit(item)">
                                    Submit&nbsp;
                                </button>     
                            </div>              
                        </div>
                    </div>
                    <div class="child">
                        <div v-for="child in item.replies" :key="child.id" class="comment">
                            <div class = "child_top">
                                <span class = "child_label strong">
                                    {{child.label}}
                                </span>
                                <span class = "child_comment"> 
                                    {{child.comment}}
                                </span>
                            </div>
                            <div class = "child_bottom">
                                <span class="date small-font color-grey"> {{formatDate(child.date)}} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="line-wrapper">
                <hr class="line">
            </div>
        </div>
    </div>

</template>

<script>
import GridCard from '@/components/Grid/Card'
import { formatShortDateTime, formatShortDate} from '@/lib/util'
import Media from 'vue-media';
import LoadingSecondary from '@/components/Loading/Secondary'

export default {
    name: 'adx-discussions',
    props: {
        list:{
            required: true
        },
        replyLoading: {
            required: false
        }
    },
    data(){
        return{
            isShow: [],
            isShowArr: [],
            isShowBast: [],
            isShowMockup: []
        }
    },
    mounted() {

    },
    components: {
        'grid-card': GridCard,
        'media': Media,
        'loading-secondary': LoadingSecondary
    },
    methods:{
        formatDate(date) {
            let today = new Date()
            let yesterday = new Date()
            yesterday = formatShortDate(yesterday.setDate(today.getDate() - 1))
            today = formatShortDate(today)
            let shortDateTime = formatShortDateTime(date).split(',')
            let dateTime = shortDateTime[0]
            let hourTime = shortDateTime[1]

            if (today === dateTime){
                dateTime = "Today"
            }
            if (yesterday === dateTime){
                dateTime = "Yesterday"
            }

            return dateTime + ' ' + hourTime
        },
        reply(item){
            this.isShow[item.id] = true
            if (!this.isShowArr.includes(item.id)){
                this.isShowArr = []
                this.isShowArr.push(item.id)
            } else{
                let indexof = this.isShowArr.indexOf(item.id)
                this.isShowArr.splice(indexof)
            }
        },
        showBast(item){
            // this.isShow[item.id] = true
            // console.log(this.isShow, this.isShowBast.includes(item.id))
            // if (!this.isShowBast.includes(item.id)){
            //     this.isShowBast.push(item.id)
            // } else{
            //     let indexof = this.isShowBast.indexOf(item.id)
            //     this.isShowBast.splice(indexof)
            // }
            window.scrollTo(0,0);
            this.emitBast()
        },
        showMockup(item){
            // this.isShow[item.id] = true
            // console.log(this.isShow, this.isShowMockup.includes(item.id))
            // if (!this.isShowMockup.includes(item.id)){
            //     this.isShowMockup.push(item.id)
            // } else{
            //     let indexof = this.isShowMockup.indexOf(item.id)
            //     this.isShowMockup.splice(indexof)
            // }
            window.scrollTo(0,0);
            this.emitMockup()
        },
        isShowMethod(item){
            let ret = this.isShow[item]
            return ret
        },
        colorSelection(item){
            if (!this.isShowArr.includes(item.id)){
                return 'reply color-black strong'
            } else{
                return 'reply colorChange'
            }
        },
        bastButtonClass(item){
            if (!this.isShowBast.includes(item.id)){
                return 'btn-regular secondary'
            } else{
                return 'btn-regular secondary hidden'
            }
        },
        mockupButtonClass(item){
            if (!this.isShowMockup.includes(item.id)){
                return 'btn-regular secondary'
            } else{
                return 'btn-regular secondary hidden'
            }
        },
        emitSubmit(item) {
            if (!this.replyLoading) {
                let comment = this.$refs.content[0].value
                let indexof = this.isShowArr.indexOf(item.id)
                this.isShowArr.splice(indexof)
                this.$emit('submitComment', comment, item)
            }
        },
        emitMockup(){
            this.$emit('goToMockup')
        },
        emitBast(){
            this.$emit('goToBast')
        }    
    }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>